import styled from 'styled-components';
export var Header = styled.header.withConfig({
  displayName: "Header",
  componentId: "sc-i6bdj7-0"
})(["margin:18px 0;"]);